import {useEffect,useRef,useState} from 'react';
import {useAppearance} from './AppearanceProvider';
import './entry-portal.css';

// A single SVG and composited layers keep the entrance vivid without a video download.
export default function EntryPortal({className=''}){
  const {preferences}=useAppearance();
  const root=useRef(null),[visible,setVisible]=useState(true);
  useEffect(()=>{if(!root.current||typeof IntersectionObserver!=='function')return;const observer=new IntersectionObserver(([entry])=>setVisible(entry.isIntersecting));observer.observe(root.current);return()=>observer.disconnect();},[]);
  return <div ref={root} className={`tl-entry-portal ${className}`} data-quiet={preferences.quiet} data-scene-active={visible&&!preferences.quiet} aria-hidden="true">
    <div className="tl-entry-halo"/><div className="tl-entry-horizon"/>
    <div className="tl-entry-rings">{[0,1,2].map(i=><i key={i} style={{'--ring':i}}/>)}</div>
    <svg className="tl-entry-market" viewBox="0 0 480 420" fill="none">
      {[128,158,116,141,102,89,109,74,51].map((y,i)=><g key={i} style={{'--candle':i}}><path d={`M${68+i*43} ${y}v${94-i*3}`}/><rect x={58+i*43} y={y+22} width="20" height={34+i*3} rx="2"/></g>)}
      <path className="tl-entry-trace" pathLength="1" d="M46 315C98 331 103 274 148 287S204 240 253 249S302 190 338 183S380 132 435 116"/>
    </svg><div className="tl-entry-ray"/><span className="tl-entry-coordinate">YOUR NEXT CHAPTER / TRADELOG</span>
  </div>;
}
